// extracted by mini-css-extract-plugin
module.exports = {"chooser":"TeamChooser_chooser__2exg7","chooser__item":"TeamChooser_chooser__item__3_jgV","chooser__item_active":"TeamChooser_chooser__item_active__1Od5w"};